import React, { useState } from "react";
import "./DeleteModal.css";
function DeleteModal({ set, handeleDelete, question }) {
  const handleClick = () => {
    set(false);
  };
  const DeleteOnClick = () => {
    handeleDelete();
    set(false);
  };
  return (
    <div className="">
      <p className="delete__title">
        {!question ? "Вы уверены, что хотите удалить?" : question}
      </p>
      <div className="btns__delete">
        <button onClick={DeleteOnClick}>Да</button>
        <button onClick={handleClick}>Отменить</button>
      </div>
    </div>
  );
}

export default DeleteModal;
